import { render, staticRenderFns } from "./CNCF-lab.vue?vue&type=template&id=ba686dfe&scoped=true&"
import script from "./CNCF-lab.vue?vue&type=script&lang=js&"
export * from "./CNCF-lab.vue?vue&type=script&lang=js&"
import style0 from "./CNCF-lab.vue?vue&type=style&index=0&id=ba686dfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba686dfe",
  null
  
)

export default component.exports